import React from "react";
import Link from "next/link";
import * as Text from "@/components/text";
import SvgLogo from "@/components/lib/SvgLogo";

export default function Footer() {
  return (
    <div className="grid w-full grid-cols-2 gap-5 md:grid-cols-4 lg:grid-cols-6">
      <div className="md:col-span-1">
        <Text.Overline className="mb-6 text-neutral-400 " as="h4">
          PARA TI
        </Text.Overline>
        <ul className="space-y-4">
          <li>
            <Link href="/catalogo" passHref>
              <Text.Link label="Películas"></Text.Link>
            </Link>
          </li>
          <li>
            <Link href="/calendario" passHref>
              <Text.Link label="Calendario"></Text.Link>
            </Link>
          </li>
          <li>
            <Link href="/prensa" passHref>
              <Text.Link label="Centro de prensa"></Text.Link>
            </Link>
          </li>
        </ul>
      </div>
      <div className="md:col-span-1">
        <Text.Overline className="mb-6 text-neutral-400 " as="h4">
          INICIATIVAS
        </Text.Overline>
        <ul className="space-y-4">
          <li>
            <Link href="/iniciativa/gira/" passHref>
              <Text.Link label="Gira Ambulante"></Text.Link>
            </Link>
          </li>
          <li>
            <Link href="/ambulante-mas-alla" passHref>
              <Text.Link label="Ambulante Más Allá"></Text.Link>
            </Link>
          </li>
          <li>
            <Link href="/ambulante-presenta" passHref>
              <Text.Link label="Ambulante Presenta"></Text.Link>
            </Link>
          </li>
          <li>
            <Link href="/ambulante-ediciones" passHref>
              <Text.Link label="Ambulante Ediciones"></Text.Link>
            </Link>
          </li>
        </ul>
      </div>
      <div className="md:col-span-1">
        <Text.Overline className="mb-6 text-neutral-400 " as="h4">
          NOSOTROS
        </Text.Overline>
        <ul className="space-y-4">
          <li>
            <Link href="/sobre-nosotros/" passHref>
              <Text.Link label="Sobre Ambulante"></Text.Link>
            </Link>
          </li>
          <li>
            <Link href="/equipo/" passHref>
              <Text.Link label="Equipo"></Text.Link>
            </Link>
          </li>
          <li>
            <Link href="/vacantes/" passHref>
              <Text.Link label="Vacantes"></Text.Link>
            </Link>
          </li>
          <li>
            <Link href="/aviso-de-privacidad/" passHref>
              <Text.Link label="Aviso de Privacidad"></Text.Link>
            </Link>
          </li>
          <li>
            <Link href="/contraloria-social/" passHref>
              <Text.Link label="Contraloría Social"></Text.Link>
            </Link>
          </li>
          <li>
            <Link href="/contacto/" passHref>
              <Text.Link label="Contáctanos"></Text.Link>
            </Link>
          </li>
        </ul>
      </div>
      <div className="md:col-span-1">
        <Text.Overline className="mb-6 text-neutral-400 " as="h4">
          Síguenos
        </Text.Overline>
        <ul className="space-y-4">
          <li>
            <Link target="_blank" href="https://bit.ly/450Xxeb" passHref>
              <Text.Link label="WhatsApp"></Text.Link>
            </Link>
          </li>
          <li>
            <Link href="https://www.youtube.com/@ambulante" passHref>
              <Text.Link label="YouTube"></Text.Link>
            </Link>
          </li>
          <li>
            <Link href="https://www.tiktok.com/@ambulanteac/" passHref>
              <Text.Link label="TikTok"></Text.Link>
            </Link>
          </li>
          <li>
            <Link href="https://www.facebook.com/AmbulanteAC" passHref>
              <Text.Link label="Facebook"></Text.Link>
            </Link>
          </li>
          <li>
            <Link href="https://twitter.com/Ambulante" passHref>
              <Text.Link label="Twitter"></Text.Link>
            </Link>
          </li>
          <li>
            <Link href="https://www.instagram.com/ambulanteac/" passHref>
              <Text.Link label="Instagram"></Text.Link>
            </Link>
          </li>
          <li>
            <Link href="https://vimeo.com/ambulanteonline" passHref>
              <Text.Link label="Vimeo"></Text.Link>
            </Link>
          </li>
          <li>
            <Link
              href="https://www.flickr.com/photos/festival_ambulante/"
              passHref
            >
              <Text.Link label="Flickr"></Text.Link>
            </Link>
          </li>
        </ul>
      </div>
      <div className="col-span-2 space-y-4 text-center text-neutral-900 md:col-span-4 lg:col-span-2 lg:text-left">
        <div className="hidden lg:block">
          <SvgLogo className="w-[200px] " />
        </div>
        <div className="lg:hidden ">
          <div className="relative">
            <div
              className="absolute inset-0 flex items-center lg:hidden"
              aria-hidden="true"
            >
              <div className="w-full border-t border-neutral-300" />
            </div>
            <div className="relative flex justify-center">
              <span className="bg-white px-2 text-sm text-neutral-900">
                <SvgLogo className="w-[200px] " />
              </span>
            </div>
          </div>
        </div>
        <Text.Label size="lg" as="p">
          Zacatecas 142-A, Roma Norte, Cuauhtémoc, C.P. 06700, Ciudad de México
        </Text.Label>
        <div className="inline-flex gap-10">
          <a href="tel:+525555115073">
            <Text.Link size="lg" label="+52 (55) 5511 5073"></Text.Link>
          </a>
          <a href="tel:+525543332019">
            <Text.Link size="lg" label="+52 (55) 4333 2019"></Text.Link>
          </a>
        </div>
        <div>
          <Text.Body size="lg" className="text-neutral-600">
            © 2024 Ambulante. Todos los derechos reservados
          </Text.Body>
        </div>
      </div>
    </div>
  );
}
